{
  "menu": {
    "trigger": "Account menu",
    "myProfile": "My profile",
    "mySecurity": "Account & security",
    "myRoles": "Roles & permissions",
    "applyToHost": "Apply to host a competition",
    "signOut": "Sign out",
    "manageEvent": "Manage event: {{title}}"
  },
  "profile": {
    "title": "My profile",
    "description": "View and edit your own profile.",
    "email": "Email",
    "emailVerified": "Verified",
    "emailUnverified": "Unverified",
    "displayName": "Display name",
    "organizationDisplayName": "Unit / Organization (optional)",
    "organizationHint": "This is self-reported information; it is not verified by the platform and does not grant any organizer or admin identity.",
    "locale": "Language",
    "timezone": "Time zone",
    "timezoneHint": "Currently shown as: {{formatted}}",
    "save": "Save changes",
    "saving": "Saving…",
    "saved": "Profile updated.",
    "error": "Could not save your profile. Please try again."
  },
  "security": {
    "title": "Account & security",
    "description": "Manage your password and the devices currently signed in.",
    "passwordSection": {
      "title": "Password",
      "currentPassword": "Current password",
      "newPassword": "New password",
      "newPasswordHint": "Must be at least 10 characters.",
      "change": "Change password",
      "changing": "Changing…",
      "success": "Password updated. For your security, other devices may need to sign in again.",
      "wrongCurrentPassword": "Current password is incorrect.",
      "genericError": "Could not change your password. Please try again.",
      "oidcOnlyTitle": "Managed by your identity provider",
      "oidcOnlyDescription": "This account signs in through an external identity provider and has no local password to change here."
    },
    "sessionsSection": {
      "title": "Active devices",
      "description": "Devices currently signed in to your account.",
      "current": "This device",
      "lastSeen": "Last active {{when}}",
      "revoke": "Sign out",
      "revoking": "Signing out…",
      "revokeOthers": "Sign out other devices",
      "revokeOthersDisabledReason": "There are no other signed-in devices right now.",
      "revokeOthersConfirmTitle": "Sign out other devices?",
      "revokeOthersConfirmDescription": "This immediately signs your account out everywhere except this device.",
      "empty": "No other signed-in devices.",
      "unknownDevice": "Unknown device",
      "revokeOthersSuccess": "Other devices have been signed out."
    },
    "emailSection": {
      "title": "Email",
      "current": "Current email: {{email}}",
      "pending": "A change request is pending verification: {{email}} (link expires {{expiresAt}})",
      "newEmail": "New email",
      "currentPassword": "Current password",
      "request": "Request change",
      "requesting": "Requesting…",
      "success": "A verification link was sent — check the new address and follow it to complete the change.",
      "wrongCurrentPassword": "Current password is incorrect.",
      "alreadyInUse": "This email is already associated with another account.",
      "genericError": "Could not request the change. Please try again.",
      "oidcOnlyDescription": "This account signs in through an external identity provider — your active session alone is enough to request a change."
    },
    "emailVerify": {
      "title": "Confirm email change",
      "description": "Confirm switching your sign-in email to the new address this link specifies.",
      "invalidLink": "This link is invalid. Please request the email change again from your account settings.",
      "confirm": "Confirm change",
      "confirming": "Confirming…",
      "success": "Your email was changed to {{email}}.",
      "failed": "This link is invalid or has expired. Please request the email change again."
    },
    "dataSection": {
      "title": "Data export & account erasure",
      "description": "Download the personal data the platform holds about you, or request that your account be erased.",
      "exportTitle": "Export my data",
      "exportDescription": "Downloads a JSON file with your profile, competition roles, team memberships, submissions, student eligibility records, judging-related data, and more.",
      "export": "Export data",
      "exporting": "Exporting…",
      "exportError": "Could not export your data. Please try again.",
      "erasureTitle": "Delete my account",
      "erasureDescription": "A Platform Admin reviews erasure requests. Once approved, your name, email, and other identifying details are anonymized and your login credentials are permanently deleted. Historical competition records (submissions, scores, results, etc.) are kept but anonymized, to preserve the integrity of competition results. This cannot be undone.",
      "erasurePending": "You have a pending account erasure request awaiting Platform Admin review.",
      "cancelRequest": "Cancel request",
      "cancelling": "Cancelling…",
      "requestErasure": "Request account deletion",
      "confirmTitle": "Request account deletion?",
      "confirmDescription": "This cannot be undone. Once approved, you will no longer be able to sign in to this account.",
      "currentPassword": "Current password",
      "reasonLabel": "Reason (optional)",
      "wrongCurrentPassword": "Current password is incorrect.",
      "requestError": "Could not submit the request. Please try again.",
      "submitting": "Submitting…",
      "confirmSubmit": "Confirm deletion request"
    }
  },
  "roles": {
    "title": "Roles & permissions",
    "description": "This screen is read-only; it has no editing controls. If a role looks wrong, contact that competition's admin or a platform administrator.",
    "platformRoleTitle": "Platform role",
    "platformRoleNone": "No platform-level role.",
    "competitionRolesTitle": "Competition roles",
    "competitionRolesEmpty": "You do not currently hold a role in any competition.",
    "loadError": "Could not load your role information. Please try again."
  }
}
